import { render, staticRenderFns } from "./dadosLoja.vue?vue&type=template&id=649ecf2a&"
import script from "./dadosLoja.vue?vue&type=script&lang=js&"
export * from "./dadosLoja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports